import React from 'react'

const SearchItem = ({ children, className, onClick, onMouseEnter }) => (
  <div onMouseDown={(e) =>{ if (e.button === 0) { onClick(e) }}} onMouseEnter={onMouseEnter} className={className}>
    { children }
  </div>
)

export default SearchItem
